import styled from 'styled-components'

export const List = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray200}`,
  borderRadius: theme.border.radius['8'],
  overflow: 'hidden',
}))

export const Item = styled.div(({ theme }) => ({
  '&:nth-child(odd)': {
    backgroundColor: theme.colors.gray100,
  },
  alignItems: 'center',
  color: theme.colors.black600,
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: 500,
  gap: theme.space['8'],
  justifyContent: 'space-between',
  padding: `${theme.space['10']} ${theme.space['16']}`,
}))

export const Value = styled.span(({ theme }) => ({
  color: theme.colors.black700,
  textAlign: 'right' as const,
}))
